import React, { useContext, useEffect, useState } from 'react';
import TeacketContext from 'src/context/TeacketContext';
import useAsyncProcesses from 'src/hooks/useAsyncProcesses';
import SearchServiceUser from 'src/components/pages/Teacket/Components/ServiceUserPicker';
import PropertySection from 'src/components/layout/PropertySection';
import { notArrayOrEmpty, notEmptyArray } from 'src/misc/Misc';
import { Alert, Button, Modal, Skeleton, Space, notification } from 'antd';
import { postTicketMember, getTicketMembers, deleteTicketMember } from 'src/api/teacket';
import TicketMembersItem from './TicketMembersItem';
import { IoPersonAdd } from 'react-icons/io5';
import NoData from 'src/components/layout/NoData';
import useUserInfo from 'src/hooks/useUserInfo';
import { MASTER_ADMIN_PERMISSION } from 'src/misc/Config';

//import PropTypes from 'prop-types';

const TicketMembers = () => {
  const { currentTicket, getCurrentTicketService, currentTicketMembers, setCurrentTicketMembers, currentTicketReadOnly, setCurrentTicketReadOnly } = useContext(TeacketContext);
  const { executeAsyncProcess, isBusy } = useAsyncProcesses();
  const { id: userId, permissions: userPermissions } = useUserInfo();

  const [currentTicketService, setCurrentTicketService] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [addAsOpen, setAddAsOpen] = useState(false);

  //#region "USE EFFECTS"

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (!currentTicket) return;
    const cts = getCurrentTicketService();
    //console.log('currentTicketService:', cts);
    setCurrentTicketService(cts);
  }, [currentTicket]);

  useEffect(() => {
    if (!addAsOpen) setSelectedUser(null);
  }, [addAsOpen]);

  useEffect(() => {
    if (notEmptyArray(userPermissions) && userPermissions.includes(MASTER_ADMIN_PERMISSION)) {
      setCurrentTicketReadOnly(false);
      return;
    }
    if (true === notArrayOrEmpty(currentTicketMembers)) setCurrentTicketReadOnly(true);
    else if (!currentTicketMembers.some((x) => x.user_id === userId)) setCurrentTicketReadOnly(true);
    else setCurrentTicketReadOnly(false);
  }, [currentTicketMembers]);

  //#endregion

  //#region "MISC"

  const loadData = async () => {
    console.log('loadData()');
    await executeAsyncProcess(async () => {
      try {
        const result = await getTicketMembers(currentTicket.id);
        setCurrentTicketMembers(result);
      } catch (error) {
        console.error(error);
      }
    });
  };

  //#endregion

  //#region "EVENT HANDLERS"

  const handleOnUserSelect = (user) => {
    console.log('handleOnUserSelect()', user);
    setSelectedUser(user);
  };

  const handleAddAs = async (role) => {
    console.log('handleAddAs()', role);
    await executeAsyncProcess(async () => {
      try {
        const newMember = await postTicketMember(currentTicket.id, selectedUser.user_id, role);
        console.log('newMember:', newMember);
        const m = true === notEmptyArray(currentTicketMembers) ? [...currentTicketMembers, newMember] : [newMember];
        setCurrentTicketMembers(m);
        setAddAsOpen(false);
        notification.success({ message: 'People successfully updated' });
      } catch (error) {
        console.error(error);
      }
    });
  };

  const handleAddAsCancel = () => setAddAsOpen(false);

  const handleOnRemove = async (user_id) => {
    console.log('handleOnRemove()', user_id);
    await executeAsyncProcess(async () => {
      try {
        await deleteTicketMember(currentTicket.id, user_id);
        const m = currentTicketMembers.filter((x) => x.user_id !== user_id);
        setCurrentTicketMembers(m);
        notification.success({ message: 'People successfully updated' });
      } catch (error) {
        console.error(error);
      }
    });
  };

  //#endregion

  return (
    <>
      <Modal title='Add a person' open={addAsOpen} onCancel={handleAddAsCancel} footer={[]} forceRender={true}>
        <div className='text-left'>
          {addAsOpen && (
            <div className={isBusy && 'disabled'}>
              <SearchServiceUser serviceId={currentTicket.service_id} onSelect={handleOnUserSelect} />
              {selectedUser && true === notEmptyArray(currentTicketService.props.roleList) && (
                <>
                  {notEmptyArray(currentTicketMembers) && currentTicketMembers.some((x) => x.user_id === selectedUser.user_id) ? (
                    <div className='mt-4'>
                      <Alert message='The person is already a member of this ticket' type='warning' showIcon />
                    </div>
                  ) : (
                    <div className='mt-4'>
                      <div className='text-center'>Select a role for this person:</div>
                      <div className='flex flex-col gap-2 mt-2'>
                        {currentTicketService.props.roleList.map((role) => (
                          <Button
                            disabled={role.maxItems && currentTicketMembers?.filter((x) => x.role === role.role).length >= role.maxItems}
                            key={role.role}
                            className='w-full'
                            onClick={() => {
                              handleAddAs(role.role);
                            }}
                          >
                            {role.role}
                          </Button>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </Modal>
      <div className='flex flex-col gap-2'>
        <PropertySection>
          <div className='flex flex-col  gap-2 mx-4 my-2 justify-center'>
            {null === currentTicketMembers && (
              <div>
                <Skeleton active avatar paragraph={{ rows: 0 }} />
                <Skeleton active avatar paragraph={{ rows: 0 }} />
                <Skeleton active avatar paragraph={{ rows: 0 }} />
              </div>
            )}
            {currentTicketMembers?.length === 0 && <NoData label='Nobody is assigned yet' />}
            {currentTicketMembers?.length > 0 && currentTicketMembers.map((member) => <TicketMembersItem member={member} onRemove={handleOnRemove} readOnly={currentTicketReadOnly} />)}
            {/* {true === notEmptyArray(members) ? members.map((member) => <TicketMembersItem member={member} onRemove={handleOnRemove} />) : <NoData label='Nobody is assigned yet' />} */}
          </div>
        </PropertySection>

        <Button type='text' onClick={() => setAddAsOpen(true)} disabled={currentTicketReadOnly}>
          <Space className='btn'>
            <IoPersonAdd />
            Add a person
          </Space>
        </Button>
      </div>
    </>
  );
};

TicketMembers.propTypes = {};

export default TicketMembers;
